import { Injectable } from "@angular/core";
import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, Router } from "@angular/router";
import { Observable } from "rxjs";
import { WebShopService } from "../services/webShop.service";
import { BottomSheetHelperService } from "../services/bottomSheetHelper.service";
import { CoreLanguageService } from "../services/language.service";
import { CoreLogService } from "../services/log.service";

@Injectable({
  providedIn: "root"
})
export class WebshopServiceGuard implements CanActivate {

  constructor(private _router: Router
    , private _coreLogService: CoreLogService
    , private _webShopService: WebShopService) {
  }

  canActivate(next: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> | Promise<boolean> | boolean {
    const me = this;
    return new Promise<boolean>((resolve, reject) => {
      me._webShopService.getFullyLoadedObservable.subscribe(() => {
        me._webShopService.getWebshopSettingsDataModel().then(settings => {
        if (settings.vacation_notification == null || settings.vacation_notification) {
          me._webShopService.openVacationWarningDialog();
          resolve(false);
        } else {
          if (me._webShopService.getServiceMode() != null && me._webShopService.getServiceLocation()) {
            resolve(true);
          } else {
            me._router.navigateByUrl("/menuservice");
            resolve(false);
          }
        }
      }).catch(e => {
        me._coreLogService.error("WebshopServiceGuard.canActivate", "_webshopService.getWebshopSettingsDataModel", e);
        resolve(false);
      });
    });
    });
  }
}
